import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import Button from 'components/button/button';
import Text from 'components/text/text';
import messages from './messages';

function ProductSizeOverlay(props) {
  const { intl, label, field, value, unit } = props;

  const itemSize = intl.formatMessage(messages[`overlay_${field}_label`])
  const bodyContent = intl.formatMessage(messages[`overlay_${field}_details`])

  return (
    <div className="container container_centered">
      <div className="set mix-set_centered mix-set_wide">
        <div className="set-hd">
          <Text
            type="sm"
            color="DarkGray"
            className="mix-txt_uppercase"
          >
            {label}
          </Text>
        </div>

        <div className="set-bd">
          <Text
            type="lg"
            color="Darkest"
            className="txt_light mix-txt_uppercaseLg"
          >
            {itemSize}
          </Text>
        </div>

        <div className="set-bd set-bd_giant">
          <div className="block">
            <div className="block-item block-item_lg">
              <Text
                color="Darkest"
                height="flat"
                tag="span"
                type="giant"
                className="txt_light mix-txt_squeeze"
              >
                {value}<span className="txt txt_light txt_xl">{unit}</span>
              </Text>
            </div>
          </div>
        </div>

        <div className="set-bd set-bd_super">
          <Text
            type="md"
            color="DarkGray"
            className="txt_light"
          >
            {bodyContent}
          </Text>
        </div>

        <div className="set-bd set-bd_giant">
          <Button animateOnClick onClick={props.onCloseClick} theme="light btn_fixedWidthMd">
            {intl.formatMessage(messages.overlay_close_label)}
          </Button>
        </div>
      </div>
    </div>
  );
}

ProductSizeOverlay.propTypes = {
  'field': PropTypes.oneOf([
    'bike_size',
    'saddle_height',
    'saddle_size',
    'shoe_size'
  ]),
  'label': PropTypes.string,
  'onCloseClick': PropTypes.func,
  'unit': PropTypes.string,
  'value': PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

export default injectIntl(ProductSizeOverlay);



// WEBPACK FOOTER //
// ./src/client/pages/product-matches/_product-size-overlay.jsx